module.exports = __webpack_public_path__ + "img/871d58bdda3628d57a6f0d5655f94671.png";